import React from 'react';
import ReactDOM from 'react-dom';

import ResourcePortalIndex from './Components/ResourcePortal/Index';

import {HashRouter as Router} from "react-router-dom";

// Sets the old bootstrap menus active or inactive based on hash value of url
function setLegacyMenuActive() {
    const hasUrl = window.location.hash.slice(2);

    document.querySelectorAll('#menubar1 > li').forEach(el => {
        el.className = el.id === `menu-${hasUrl}` ? 'active' : '';
    })
}

// Entrypoint
ReactDOM.render(
    <Router>
        <ResourcePortalIndex/>
    </Router>,
    document.getElementById('root')
);

// Legacy support: Old website menu
setLegacyMenuActive();
window.addEventListener("hashchange", setLegacyMenuActive);